import { checkPasswordResetClaim } from '@/api/auth';
import { handleError } from '../common';

export default async (code: string) => {
  try {
    await checkPasswordResetClaim(code);
  } catch (error) {
    error = handleError(error);
    throw error;
  }
};